import { createSelector } from '@reduxjs/toolkit';
import { ECompletionYearType } from '../../../../packages/JsonQuery';
import {
  selectBuildingCompletionYear,
  selectBuildingHandOverFromYear,
  selectBuildingHandOver,
} from 'shared/selectors/jsonQuery';
import { AVAILABLE_COMPLETION_YEAR_TYPES, CURRENT_YEAR } from './constants';

export const selectCompletionYearValue = createSelector(
  [selectBuildingCompletionYear, selectBuildingHandOverFromYear, selectBuildingHandOver],
  (buildingCompletionYear, buildingHandOverFromYear, buildingHandOver) => {
    const completionYearTypes: ECompletionYearType[] = [];

    if (buildingHandOver) {
      completionYearTypes.push(ECompletionYearType.HandedOver);
    }

    if (buildingCompletionYear && buildingCompletionYear.length > 0) {
      const filteredYear = buildingCompletionYear
        .map(value => value - CURRENT_YEAR)
        .filter(value => AVAILABLE_COMPLETION_YEAR_TYPES.includes(value)) as ECompletionYearType[];

      completionYearTypes.push(...filteredYear);
    }

    if (buildingHandOverFromYear) {
      completionYearTypes.push(ECompletionYearType.Later);
    }

    return completionYearTypes.length > 0 ? completionYearTypes : [null];
  },
);
